import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function DropLanguage() {
  const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);

  const languages = [
    {
      value: 'es',
      label: t('languages.es'),
      flag: '/assets/media/flags/mexico.svg'
    },
    {
      value: 'en',
      label: t('languages.en'),
      flag: '/assets/media/flags/united-states.svg'
    },
    {
      value: 'zh',
      label: t('languages.zh'),
      flag: '/assets/media/flags/china.svg'
    }
  ];

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
    setCurrentLang(language);
    const event = new Event('languageChanged');
    window.dispatchEvent(event);
  };

  useEffect(() => {
    setCurrentLang(i18n.resolvedLanguage || 'es');
  }, [i18n.language]);

  const currentLanguage = languages.find((lang) => lang.value === currentLang) || languages[0];

  return (
    <div
      className="menu-item px-5 cursor-pointer"
      data-kt-menu-trigger="{default: 'hover', lg: 'hover'}"
      data-kt-menu-placement="bottom-start"
      data-kt-menu-offset="-15px, 0"
    >
      <span>
        <span className="menug-title">
          <span className="btn btn-icon btn-active-light-primary w-100px h-30px w-md-100px h-md-30px">
            <img
              className="w-15px h-15px bg-primary rounded-circle ms-2"
              src={currentLanguage.flag}
              alt="imageCh"
            />{' '}
            <span className="ms-2 mw-75px">{currentLanguage.label}</span>
          </span>
        </span>
      </span>
      <div
        className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-gray-500 menu-active-bg menu-state-color fw-semibold py-4 fs-base w-150px"
        data-kt-menu="true"
      >
        {languages.map((language) => (
          <div key={language.value} className="menu-item px-3 my-0">
            <button
              type="button"
              className={`btn menu-link w-130px px-3 py-2 ${currentLang === language.value ? 'active' : ''}`}
              onClick={() => changeLanguage(language.value)}
            >
              <span className="menu-icon">
                <img
                  alt="imageCh"
                  src={language.flag}
                  className="rounded-circle me-2"
                  height={'16px'}
                  title={`languages-${language.value}`}
                />
              </span>
              <span className="menu-title">{language.label}</span>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DropLanguage;
